import { render, staticRenderFns } from "./VersionDropdown.vue?vue&type=template&id=635c531c&"
import script from "./VersionDropdown.vue?vue&type=script&lang=js&"
export * from "./VersionDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports